// src/services/cityService.js
import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_CORE_URL;

// Obtener una ciudad por su ID
export const getCityById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/city/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Eliminar una ciudad
export const deleteCity = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/city/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Crear una nueva ciudad
export const saveCity = async (city) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/city`, city);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
